// extracted by mini-css-extract-plugin
export default {"image":"B3-z","loaded":"C3-z"};